import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { loadAvatar } from '../lib/avatars';

function initials(name: string) {
  const parts = name
    .replace(/^(dr\.|prof\.)\s+/i, '')
    .split(/\s+/)
    .filter(Boolean);
  return ((parts[0]?.[0] ?? '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
}

/**
 * Round profile picture with initials as fallback.
 * avatarAt: upload time of the picture (null = no picture; undefined = unknown, ask the server).
 */
export function Avatar({ personId, name, avatarAt, size = 28, className }: { personId: string; name: string; avatarAt?: string | null; size?: number; className?: string }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    setSrc(null);
    if (avatarAt === null) return;
    let alive = true;
    loadAvatar(personId, avatarAt ?? '')
      .then((s) => alive && setSrc(s))
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [personId, avatarAt]);
  return (
    <span
      className={clsx('inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-accent-soft font-semibold text-accent select-none', className)}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.38)) }}
      aria-hidden
    >
      {src ? <img src={src} alt="" className="size-full object-cover" /> : initials(name)}
    </span>
  );
}
